import { render, staticRenderFns } from "./BasicSalary.vue?vue&type=template&id=7d149860&scoped=true&"
import script from "./BasicSalary.vue?vue&type=script&lang=js&"
export * from "./BasicSalary.vue?vue&type=script&lang=js&"
import style0 from "./BasicSalary.vue?vue&type=style&index=0&id=7d149860&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d149860",
  null
  
)

export default component.exports